module.exports = __webpack_public_path__ + "img/bio-9.70fe9da.jpg";